import { useQuery } from '@tanstack/react-query';

import { fetchPollDetails } from '../../fetchers/poll-fetchers';

const useGetPollDetails = (pollId: string) => {
  const { data, error, refetch, isLoading } = useQuery(
    [`poll_${pollId}`, { pollId }],
    fetchPollDetails,
    {
      enabled: !!pollId,

      refetchOnWindowFocus: false,
    },
  );
  return {
    data: data?.data,
    isLoading,
    error,
    refetch,
  };
};

export default useGetPollDetails;

export class PollDetail {
  _id: string;
  correct_option: Array<any> = [];
  result_duration: number;
  expiry_duration: number;
  poll_start_time: number;
  static_poll_delay: number;
  has_poll_ended: boolean;
  type: string;
  is_result_generated: boolean;
  poll_options: Array<PollDetailOptionModel> = [];
  org_id: string;
  created_at: string;
  created_by: string;
  modified_at: string;
  modified_by: string;
  total_votes: number;
  correct_votes: number;
  recordPollStartTime: number;
  isTimelessPoll: boolean;
  constructor(data: any) {
    data = data || {};
    this._id = data._id || data.pollId || '';
    this.correct_option = data.correct_option || data.correctOption || '';
    this.result_duration = data.result_duration || data.resultDuration || 0;
    this.expiry_duration = data.expiry_duration || data.expiryDuration || 0;
    this.poll_start_time = data.poll_start_time || data.pollStartTime || 0;
    this.has_poll_ended = data.has_poll_ended || data.hasPollEnded || false;
    this.static_poll_delay = data.static_poll_delay || data.staticPollDelay || 0; // second
    this.type = data.type || '';
    this.is_result_generated = data.is_result_generated || data.isResultGenerated || false;
    if (data && data.poll_options && data.poll_options.length > 0) {
      const pollOptions: Array<PollDetailOptionModel> = [];
      data.poll_options.forEach((el: PollDetailOptionModel) => {
        pollOptions.push(new PollDetailOptionModel(el));
      });
      this.poll_options = [...this.poll_options, ...pollOptions];
    }

    if (data && data.pollOptions && data.pollOptions.length > 0) {
      const pollOptions: Array<PollDetailOptionModel> = [];
      data.pollOptions.forEach((el: any) => {
        pollOptions.push(new PollDetailOptionModel(el));
      });
      this.poll_options = [...this.poll_options, ...pollOptions];
    }
    this.org_id = data.org_id || '';
    this.created_at = data.created_at || '';
    this.created_by = data.created_by || '';
    this.modified_at = data.modified_at || '';
    this.modified_by = data.modified_by || '';
    this.total_votes = data.total_votes || data.totalVotes || 0;
    this.correct_votes = data.correct_votes || data.correctVotes || 0;
    this.recordPollStartTime = data.recordPollStartTime || 0; // in seconds
    this.isTimelessPoll = data?.isTimelessPoll || false;
  }
}

export class PollDetailOptionModel {
  _id: string;
  option_id: number;
  option_label: string;
  option_description: string;
  vote_count: number;
  vote_percentage: number;
  isActive: boolean;
  constructor(data: any) {
    data = data || {};
    this._id = data._id || '';
    this.option_id = data.option_id || data.optionId || '';
    this.option_label = data.option_label || data.optionLabel || '';
    this.option_description = data.option_description || data.optionDescription || '';
    this.vote_count = data.vote_count || data.voteCount || 0;
    this.vote_percentage = data.vote_percentage || data.votePercentage || 0;
    this.isActive = false;
  }
}
